import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const editModelsSelector = (state: State) => state.editModels.entities;
export const editModelsStatusSelector = (state: State) =>
  state.editModels.status;
export const editModelsLoadedSelector = isLoaded(editModelsStatusSelector);
export const editModelsPendingSelector = isPending(editModelsStatusSelector);
export const shouldEditModelsSelector = shouldLoad(editModelsStatusSelector);
